/**
 * Property service - handles all property-related API operations
 */

import { BaseApiClient } from '../core/base-client';
import { 
  Property, 
  PropertyResponse, 
  PropertySearchFilters 
} from '../types';

export class PropertyService {
  constructor(private client: BaseApiClient) {}

  /**
   * Get properties with optional filters
   */
  async getProperties(filters?: PropertySearchFilters): Promise<PropertyResponse> {
    // Convert filters to query parameters for GET request
    const queryParams = new URLSearchParams();
    
    if (filters) {
      Object.entries(filters).forEach(([key, value]) => {
        if (value !== undefined && value !== null) {
          if (Array.isArray(value)) {
            // Handle array values
            value.forEach(v => queryParams.append(key, v.toString()));
          } else if (value instanceof Date) {
            // Handle Date objects
            queryParams.append(key, value.toISOString());
          } else {
            queryParams.append(key, value.toString());
          }
        }
      });
    }
    
    const queryString = queryParams.toString();
    const url = queryString ? `/api/properties?${queryString}` : '/api/properties';
    
    return this.client.get<PropertyResponse>(url);
  }

  /**
   * Get a single property by ID
   */
  async getProperty(id: number): Promise<Property> {
    return this.client.get<Property>(`/api/properties/${id}`);
  }
}

/**
 * Factory function to create property service
 */
export function createPropertyService(client: BaseApiClient): PropertyService {
  return new PropertyService(client);
} 